<template>

    <div class="box">
        <div class="title">
            <span class="text-linear-gradieant">城投能源智能出行平台</span>
        </div>
        <div class="container">
            <el-row>
                <el-col v-for="item in menu" :xs="12" :sm="12" :md="12" :lg="8" :xl="8" style="text-align: center">
                    <div class="router-link">
                        <a :href="item.url" target="_blank">
                            <div class="link-icon"><img :src="''+item.icon"></div>
                            <p class="link-title text-linear-gradieant">{{item.name}}</p>
                        </a>
                    </div>
                </el-col>
            </el-row>
            <el-row v-if="this.key">
                <div style="text-align: center;">
                    <router-link to="/logout"><span style="color: white">退出登录</span></router-link>
                </div>
            </el-row>
        </div>
    </div>
</template>

<script>
    import operate_icon from '../../assets/img/operate_icon.png';
    import invoice from '../../assets/img/invoice.png';
    import monitor from '../../assets/img/monitor.png';
    import bigdata from '../../assets/img/bigdata.png';
    import oa from '../../assets/img/oa.png';
    import auth from '../../assets/img/auth.png';

    export default {
        name: 'Home.vue',
        data:function() {
            return {
                key:'',
                menu: [],
                error:''
            }
        },
        created() {
            this.error = this.$route.query.error;
            if (this.error){
                this.$message.error(this.error)
            }
            this.key = localStorage.getItem("sso-key");
            console.log("key:",this.key)
            this.menu = [
                {
                    name:'营运管理',
                    url:process.env.NODE_ENV === 'development'?
                        'http://taxi.manage.test.yuntuzl.com:8888/operate'
                        :
                        'https://taxi.manage.yuntuzl.com/operate',
                    // 'http://taxi.manage.test.yuntuzl.com:8888/operate',
                    icon:operate_icon
                },
                // {
                //     name:'财务管理',
                //     url:process.env.NODE_ENV === 'development'?
                //         'http://192.168.18.201:8084/taxifee':'https://taxi.manage.yuntuzl.com/taxifee',
                //     icon:'/static/images/finance.png'
                // },
                {
                    name:'发票管理',
                    url:process.env.NODE_ENV === 'development'?
                        'http://taxi.manage.test.yuntuzl.com:8888/invoice'
                        :
                        'https://taxi.manage.yuntuzl.com/invoice',
                    // 'http://taxi.manage.test.yuntuzl.com:8888/invoice',
                    icon:invoice
                },{
                    name:'监控中心',
                    url: process.env.NODE_ENV === 'development'?
                        'http://taxi.saas.api.test.yuntuzl.net:8888/sso/manage/sso/login/gotoMonitor?key='+(this.key?this.key:'')
                        :
                        // this.key?'http://taxi.saas.api.test.yuntuzl.net:8888/sso/manage/sso/login/gotoMonitor?key='+this.key:"http://taxi.manage.test.yuntuzl.com:8888/sso/#/login",
                        'https://taxi.saas.api.yuntuzl.net/sso/manage/sso/login/gotoMonitor?key='+(this.key?this.key:''),
                    icon: monitor
                },
                {
                    name:'大数据中心',
                    url: process.env.NODE_ENV === 'development'?
                        'http://taxi.saas.api.test.yuntuzl.net:8888/sso/manage/sso/login/gotoBigdata?key='+(this.key?this.key:'')
                        :
                        // this.key?'http://taxi.saas.api.test.yuntuzl.net:8888/sso/manage/sso/login/gotoMonitor?key='+this.key:"http://taxi.manage.test.yuntuzl.com:8888/sso/#/login",
                        'https://taxi.saas.api.yuntuzl.net/sso/manage/sso/login/gotoBigdata?key='+(this.key?this.key:''),
                    icon:bigdata
                },
                {
                    name:'OA管理',
                    url: process.env.NODE_ENV === 'development'?
                        'http://taxi.manage.test.yuntuzl.com:8888/oa/login'
                        :
                        'https://taxi.manage.yuntuzl.com/oa/login',
                    // 'http://taxi.manage.test.yuntuzl.com:8888/oa',
                    icon: oa
                },
                {
                    name:'权限管理',
                    url:process.env.NODE_ENV === 'development'?
                        'http://taxi.manage.test.yuntuzl.com:8888/sso/#/casLogin'
                        :
                        'https://taxi.manage.yuntuzl.com/sso/#/casLogin',
                    // 'http://taxi.manage.test.yuntuzl.com:8888/sso/#/casLogin',
                    icon:auth
                }
            ]
        }
    };
</script>

<style scoped>
    *{
        box-sizing: border-box;
    }
    html,body{
        margin: 0 0;
        padding:0 0;
        height: 100%;
        width: 100%;

    }
    box{
        background-color: black;
        display: flex;
        height: 100%;
        width: 100%;
        flex-direction: column;
    }
    @font-face {
        font-family: hylxtj;
        src: url('../../assets/css/HYk2gj.svg#HYk2gj') format('svg'),
        url('../../assets/css/HYk2gj.ttf') format('truetype'),
        url('../../assets/css/HYk2gj.woff') format('woff'),
        url('../../assets/css/hylxtj.woff2') format('woff2'),
        url('../../assets/css/hylxtj.eot'),
        url('../../assets/css/hylxtj.eot?#iefix') format('embedded-opentype')

    }
    .title{
        box-sizing: border-box;
        width: 100%;
        height: 4rem;
        background: url("../../assets/img/title-back.png") no-repeat center;
        background-size: 100% 100%;
        text-align: center;
    }
    .title span{
        box-sizing: border-box;
        margin: 0;
        padding: 0;
        line-height: 4rem;
        letter-spacing: 0.2rem;
        font-family: hylxtj;
        font-size: 1.8rem;
    }
    .text-linear-gradieant{
        background: linear-gradient(to bottom, #BCDFE1, #8AC5FF);
        -webkit-background-clip: text;
        color: transparent;
    }
    .container{
        width: 100%;
        flex-grow: 1;
        background: url("../../assets/img/newback.jpg") no-repeat center;
        background-size: 100% 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        top: 4rem;
        border: none;
        padding: 10% 8%;
        overflow-y: auto;
    }
    .router-link-box{
        width: 70%;
        margin: 0 auto;
        box-sizing: border-box;
        height: 80vh;
        display: flex;
        justify-content:space-around;
        flex-direction: row;
        flex-wrap: wrap;
        align-content:flex-start;

    }
    .router-link{
        /*margin-right: 2rem;*/
        /*margin-bottom: 2rem;*/
        display: inline-block;
        max-width: 22rem;
        width: 100%;
        height: 14rem;
        border-radius: 0.2rem;
        background: url("../../assets/img/btn-back.png") no-repeat center;
        background-size: 100% 100%;
    }
    .router-link .link-icon{
        width: 100%;
        height: 50%;
        padding: 2rem 0;
    }
    .router-link .link-icon img{
        width: 4rem;
    }
    .router-link .link-title{
        width: 100%;
        text-align: center;
        font-size: 1.2rem;
        line-height: 2.5rem;
        font-weight: bold;
        margin: 0;
        letter-spacing: 0.2rem;
    }
    .invalid{
    }
    .router-link:hover{
    }
    .router-link div{
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        cursor: pointer;
        font-size: 1rem;
        line-height: 5rem;
        text-align: center;
        font-family: 微软雅黑;
        font-weight: bold;
        color: white;
        letter-spacing: 0.2rem;
    }
    a{
        text-decoration: none;
    }

    @media screen and (min-width: 320px)  and (max-width: 768px) {
        .container{
            flex-grow: initial;
            height: auto;
        }
        .router-link-box{
            height: 100%;
            align-content: flex-start;
            justify-content: flex-start;
        }
    }
    @media screen and (min-width: 768px)  and (max-width: 1024px) {
        .container{
            flex-grow: initial;
            height: auto;
        }
        .router-link-box{
            height: 100%;
            align-content: flex-start;
            justify-content: center;
        }
    }
</style>
